// local language

import {loadBirdsDataOfActualLang} from "./birds-data.js";
import {reformArraysForCheckAnswer, loadCurrentBirdsFromActualLang} from './answer-list.js'
import {loadDescriptionOfActualLang} from './bird-descr.js'

const localLanguageRu = {
  header: [
    "Главная",
    "Игра",
    "Результаты",
    "Настройки",
    "Выбрать язык",
  ],
  MainPage: {
    greetings: "Приветствуем лучшего среди лучших!",
    beforeStrikethroughText: "И добро пожаловать в",
    strikethroughText:
      "в увлекательную и расслабляющую игру, в которой невозможно проиграть ",
    rules: "Правила весьма просты:",
    rule1: "6 вопросов",
    rule2: "в каждом вопросе 6 вариантов ответа",
    rule3:
      "если ответ на вопрос дан с первой попытки, счёт увеличивается на 5 баллов",
    rule4: "за каждую попытку со счёта снимается 1 балл",
    themeChange: "Ты можешь изменить тему викторины:",
    birdSongTheme: "Пение птиц",
    serialsTheme: "Саундтреки из сериалов",
    animeTheme: "Саундтреки из аниме",
    willBeLater: "(Будет добавлено позже)",
  },
  game: {
    categories: [
      "Разминка",
      "Воробьиные",
      "Лесные птицы",
      "Певчие птицы",
      "Хищные птицы",
      "Морские птицы",
    ],
    text: "Послушайте звук и выберите наиболее подходящий вариант",
    currentScore: "Текущий счёт: ",
    nextQuestion: "Следующий вопрос",
    toResults: "Перейти к результатам"
  },
  results: {
    maxResult: "Максимальное количество возможных баллов = 30 баллов",
    lastResult: "В последней игре получилось набрать = __ баллов",
    wantMore: "Попробуем набрать больше?",
    newGame: "Играть",
    main: "На главную",
    congrats: "Поздравляем, вы набрали максимум баллов! Вы можете испытать свою удачу и в других темах."
  },
};

const localLanguageEn = {
  header: [
    "Main",
    "Game",
    "Results",
    "Settings",
    "Language",
  ],
  MainPage: {
    greetings: "Welcome, the best among the best!",
    beforeStrikethroughText: "And welcome in ",
    strikethroughText:
      "an exciting and relaxing game in which it is impossible to lose",
    rules: "The rules are quite simple:",
    rule1: "6 questions",
    rule2: "there are 6 possible answers in each question",
    rule3: "if the answer to the question is given on the first attempt, the score increases by 5 points",
    rule4: "1 point is deducted from the account for each attempt",
    themeChange: "You can change the quiz topic:",
    birdSongTheme: "Birdsong",
    serialsTheme: "Soundtracks from TV series",
    animeTheme: "Anime Soundtracks",
    willBeLater: "(To be added later)",
  },
  game: {
    categories: [
      "Warm-up",
      "Sparrows",
      "Forest birds",
      "Songbirds",
      "Birds of prey",
      "Seabirds",
    ],
    text: "Listen to the sound and choose the most appropriate option",
    currentScore: "Current score: ",
    nextQuestion: "Next question",
    toResults: "To results"
  },
  results: {
    scoreFirst: "In the last game it turned out to score = ",
    scoreSecond: " points",
    maxResult: "Maximum number of possible points = 30 points",
    wantMore: "Shall we try to score more?",
    newGame: "Play",
    main: "To the main",
    congrats: "Congratulations, you have scored maximum points! You can try your luck in other topics as well."
  },
};

const serialCategoriesRu = [
  "Ситком",
  "Фэнтези",
  "Детектив/Криминал",
  "Фантастика",
  "Ужас/триллер",
  "Драма"
];

const serialCategoriesEn = [
  "Sitcom",
  "Fantasy",
  "Detective/Crime",
  "Fantastic",
  "Horror/Thriller",
  "Drama"
];


if ((localStorage.getItem('theme') == 'serials')) {
  localLanguageRu.game.categories = serialCategoriesRu;
  localLanguageEn.game.categories = serialCategoriesEn;  
} else if ((localStorage.getItem('theme') == 'birds')) {
  localLanguageRu.game.categories = [
    "Разминка",
    "Воробьиные",
    "Лесные птицы",
    "Певчие птицы",
    "Хищные птицы",
    "Морские птицы",
  ];
  localLanguageEn.game.categories = [
    "Warm-up",
    "Sparrows",
    "Forest birds",
    "Songbirds",
    "Birds of prey",
    "Seabirds",
  ]; 
}

// console.log(localLanguageRu.game.categories)

const choseLanguage = document.querySelector(".language-change__span"),
  languages = document.querySelector(".language-change");

// Language popup
choseLanguage.addEventListener("click", () => {
  
  let isVisible = languages.classList.contains("visible");
  if (isVisible) {
    languages.style.display = "none";
    languages.classList.remove("visible");
  } else {
    languages.style.display = "block";
    languages.classList.add("visible");

    
    let langs = document.querySelectorAll('.language-change__language');

    for(let lang of langs) {
      lang.addEventListener('click', () => {ploop (lang.textContent)});
    }
  }

});

loadLang(localLanguageRu, localStorage.getItem('lang') === null ? localLanguageRu : localStorage.getItem('lang') === "Русский" ? localLanguageRu : localLanguageEn);

// -----------------------------------
// saving lang


// --------------
function ploop (lang) {
  console.log("koooops");
  let oldLang = localStorage.getItem('lang') === null ? localLanguageRu : localStorage.getItem('lang') === "Русский" ? localLanguageRu : localLanguageEn;
  localStorage.setItem('lang', lang);
  loadLang(oldLang, lang === "Русский" ? localLanguageRu : localLanguageEn, true);
}

function loadLang(fromLang, toLang, shouldCallReform = false) {
  loadBirdsDataOfActualLang();
  if (shouldCallReform) {
    reformArraysForCheckAnswer();
  }
  let headerElements = document.querySelectorAll(".header-list__link");
  for (let i = 1; i < headerElements.length; i++) {
    headerElements[i].textContent = toLang.header[i - 1];
  }
  choseLanguage.textContent = toLang.header[4];
  if (document.getElementById("greeting") != null) {
    let welcome = document.getElementById("greeting");
    welcome.textContent = toLang.MainPage.greetings;
    let krestik = document.getElementById("krestik");
    krestik.textContent = toLang.MainPage.strikethroughText;
    let beforeKrestik = document.getElementById("beforeKrestik");
    beforeKrestik.textContent = toLang.MainPage.beforeStrikethroughText;
    document.getElementById("rules").textContent = toLang.MainPage.rules;
    document.getElementById("rule1").textContent = toLang.MainPage.rule1;
    document.getElementById("rule2").textContent = toLang.MainPage.rule2;
    document.getElementById("rule3").textContent = toLang.MainPage.rule3;
    document.getElementById("rule4").textContent = toLang.MainPage.rule4;
    document.getElementById("theme").textContent = toLang.MainPage.themeChange;
    document.getElementById("birdSing").textContent = toLang.MainPage.birdSongTheme;
    document.getElementById("series").textContent = toLang.MainPage.serialsTheme;
    document.getElementById("anime").textContent = toLang.MainPage.animeTheme;
    document.getElementById("later1").textContent = toLang.MainPage.willBeLater;
  }
  if (document.querySelector(".container-question__list") != null) {
    let questions = document.querySelectorAll(".container-question__question");
    for (let i = 0; i < questions.length; i++) {
      questions[i].textContent = toLang.game.categories[i];
    }
    document.getElementById("currentScore").textContent = toLang.game.currentScore;
    if (document.querySelector(".next-question") != null) {
      if (document.querySelector(".next-question").textContent === fromLang.game.nextQuestion) {
        document.querySelector(".next-question").textContent = toLang.game.nextQuestion;
      } else {
        document.querySelector(".next-question").textContent = toLang.game.toResults;
      }
    }
    if (shouldCallReform) {
      loadCurrentBirdsFromActualLang();
      loadDescriptionOfActualLang();
    }
  }
  if (document.getElementById("scoreFirst") != null) {
    document.getElementById("scoreFirst").textContent = toLang.results.scoreFirst;
    document.getElementById("scoreSecond").textContent = toLang.results.scoreSecond;
    document.getElementById("maxScore").textContent = toLang.results.maxResult;
    document.getElementById("suggestion").textContent = toLang.results.wantMore;
    if (document.querySelector(".results-main__link").textContent === fromLang.results.newGame) {
      document.querySelector(".results-main__link").textContent = toLang.results.newGame;
    } else {
      document.querySelector(".results-main__link").textContent = toLang.results.main;
    }
    if (document.getElementById('suggestion').textContent === fromLang.results.wantMore) {
      document.getElementById('suggestion').textContent = toLang.results.wantMore;
    } else {
      document.getElementById('suggestion').textContent = toLang.results.congrats;
    }
  }
  // console.log(headerElements);
}

export {localLanguageEn, localLanguageRu}